import { useEffect } from "react";
import axios from "axios";
import { Api_Url } from "../utils/ApiUrl";

const STORAGE_KEY = "landingVisitId";

const useLandingVisitLogger = () => {
    useEffect(() => {
        const logVisit = async () => {
            try {
                const existingId = localStorage.getItem(STORAGE_KEY);
                if (existingId) return;

                const res = await axios.post(
                    `${Api_Url}/logs/landing-visit`
                );
                const id = res?.data?.data?._id;
                if (id) {
                    localStorage.setItem(STORAGE_KEY, id);
                }
            } catch (error) {
                // intentionally silent (no UX impact)
                console.error("Landing visit log failed:", error);
            }
        };

        logVisit();
    }, []);
};

export default useLandingVisitLogger;
